




import request from '@/services/api';

// 获取支付方式列表
export function PayMethodList(query) {
    return request({
        url: '/card/list',
        method: 'get',
        data: query,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}


// 获取删除支付方式
export function PayMethodDelete(id) {
    return request({
        url: '/card/delete/'+id,
        method: 'delete'
        
    })
}


// 更新支付方式
export function PayMethodUpdate(query) {
    return request({
        url: '/card/update',
        method: 'put',
        data: query,
         headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}


// 设置默认支付方式
// 传入 id   userId
export function PayMethodDefault(id) {
    return request({
        url: '/card/setDefaultCard/'+id,
        method: 'put',
        
         headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}


// 添加支付方式
export function PayMethodAdd(query) {
    return request({
        url: '/card/save',
        method: 'post',
        data: query
         
    })
}

// 设置快捷支付
export function PayMethodSetQuick(query) {
    return request({
        url: '/card/setQuickPayCard',
        method: 'put',
        data: query,
         headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
